module.exports = __webpack_public_path__ + "img/pt_class.59a0b578.gif";